<template>
  <div class="" style="background-color: transparent; border-radius: 5px;">
    <div id="map" class="" />

    <b-container class="px-2" style="position:sticky; bottom: 0; right: 25%; color: #fff; background-color: rgba(17, 24, 39, 0.75); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); border-radius: 10px;">
      <div
        v-if="countdownShow"
        ref="myModalRef"
      >
        <b-row>
          <h4 class="w-100">
            Be here in:
          </h4>
        </b-row>
        <b-row class="w-100 my-1 text-center">
          <b-col cols="3">
            <h4>
              {{ countdown_days }}
            </h4>
            <p>Days</p>
          </b-col>
          <b-col cols="3">
            <h4>
              {{ countdown_hours }}
            </h4>
            <p>Hours</p>
          </b-col>
          <b-col cols="3">
            <h4>
              {{ countdown_minutes }}
            </h4>
            <p>Minutes</p>
          </b-col>
          <b-col cols="3">
            <h4>
              {{ countdown_seconds }}
            </h4>
            <p>Seconds</p>
          </b-col>
        </b-row>
      </div>
      <b-row class="w-100 my-2 text-center">
        <b-col cols="12" class="mb-2">
          <a :href="`${googleMapURL}`" class="btn btn-outline-light btn-sm" role="button" target="_blank"><font-awesome-icon :icon="['fab', 'google']" /> Google Map</a>
          <!-- "See where fans are" hidden by default — see backlog.md -->
          <!-- <a :href="`/${handle}/p/${placeId}`" class="btn btn-secondary" role="button">See where fans are</a> -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'

export default {
  layout: 'empty',
  props: {
    currentLoc: Array,
    dropLoc: Array,
    description: String,
    handle: String,
    placeId: String,
    countdown: Number
  },
  data () {
    return {
      googleMapURL: this.currentLoc ? `https://www.google.com/maps/dir/${encodeURIComponent(this.currentLoc[1])},${encodeURIComponent(this.currentLoc[0])}/${encodeURIComponent(this.dropLoc[1])},${encodeURIComponent(this.dropLoc[0])}` : '',
      map: null,
      dropMarker: null,
      currentMarker: null,
      countdownShow: false,
      countdownTime: parseInt(this.countdown),
      countdown_days: 0,
      countdown_hours: 0,
      countdown_minutes: 0,
      countdown_seconds: 0
    }
  },
  head () {
    return {
      script: [
        {
          src: 'https://api.mapbox.com/mapbox-gl-js/v3.4.0/mapbox-gl.js',
          defer: true
        }
      ],
      link: [
        {
          rel: 'stylesheet',
          href: 'https://api.mapbox.com/mapbox-gl-js/v3.4.0/mapbox-gl.css'
        }
      ]
    }
  },
  watch: {
    currentLoc: {
      handler (val, oldVal) {
        if (val !== oldVal && this.map) {
          this.currentMarker.setLngLat(this.currentLoc)
          this.map.fitBounds([this.dropLoc, this.currentLoc], {
            padding: 80
          })
        }
      }
    }
  },
  mounted () {
    this.createMap()
    if (this.countdown && this.countdown > 0) {
      this.countdownShow = true
      this.timer = setInterval(() => {
        this.countdownTime--
        this.countdown_days = Math.floor(this.countdownTime / (60 * 60 * 24))
        this.countdown_hours = Math.floor((this.countdownTime % (60 * 60 * 24)) / (60 * 60))
        this.countdown_minutes = Math.floor((this.countdownTime % (60 * 60)) / 60)
        this.countdown_seconds = Math.floor(this.countdownTime % 60)
        if (this.countdownTime <= 0) {
          clearInterval(this.timer)
          this.countdownShow = false
        }
      }, 1000)
    }
  },
  methods: {
    createMap () {
      mapboxgl.accessToken = 'pk.eyJ1Ijoic2hpMTEiLCJhIjoieGh5WE5ydyJ9.B7LtBt8hQixasCYHY9R_gA'
      this.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/satellite-streets-v12',
        zoom: 15,
        pitch: 45,
        attributionControl: false
      })

      if (this.dropLoc) {
        this.dropMarker = new mapboxgl.Marker()
          .setLngLat(this.dropLoc)
          .setPopup(
            new mapboxgl.Popup({
              closeOnClick: false,
              closeButton: false
            }).setHTML('<span>' + this.description + '</span>')
          )
          .addTo(this.map)
          .togglePopup()
      }

      if (this.currentLoc) {
        const el = document.createElement('div')
        el.className = 'current-location-marker'
        this.currentMarker = new mapboxgl.Marker({ element: el })
          .setLngLat(this.currentLoc)
          .addTo(this.map)

        this.map.fitBounds([this.dropLoc, this.currentLoc], {
          padding: 80
        })
      }

      this.map.addControl(
        new mapboxgl.FullscreenControl({
          container: document.querySelector('body')
        })
      )
      this.map.addControl(new mapboxgl.AttributionControl(), 'top-right')

      this.map.on('load', (event) => {
        const geojson = {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: this.dropLoc
              }
            }
          ]
        }
        event.target.addSource('point', {
          type: 'geojson',
          data: geojson
        })

        event.target.addLayer({
          id: 'point',
          type: 'circle',
          source: 'point',
          paint: {
            'circle-radius': 20,
            'circle-color': '#F84C4C' // red color
          }
        })

        event.target.resize()
      })
    }
  }
}
</script>

<style>
#map {
  width: 100%;
  min-height: 85vh;
  padding-bottom: 100px;
}
a.mapboxgl-ctrl-logo {
  position:absolute !important;
  left:0 !important;
  bottom:80px !important;
}
.current-location-marker {
  width: 18px;
  height: 18px;
  background-color: #3b82f6;
  border: 3px solid white;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.5);
  animation: location-pulse 2s infinite;
}
@keyframes location-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.5); }
  70%  { box-shadow: 0 0 0 14px rgba(59, 130, 246, 0); }
  100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0); }
}

</style>

<style scoped>
h4 {
  font-family: 'Lato-Black', sans-serif;
  color: #000;
}

</style>
